// extracted by mini-css-extract-plugin
export default {"formItemStyles":"ProductionBaseTable_formItemStyles__woUvp"};